import { patch } from './helpers'

export default {
  getProductsResyncStatus(data) {
    return patch('api/junglekit/product/sync_status', { data })
  }
}
